import { useCallback, useRef } from 'react'

const defaultValue = Symbol('hoverDelay')

function useHoverDelay<T>(
  callback: (value: T, ...args: any[]) => void,
  delay?: number
): [(value: T, ...args: any[]) => void, () => void] {
  const valueRef = useRef<T | symbol>()
  const timerRef = useRef<NodeJS.Timer>()

  const start = useCallback(
    (value: T, ...args) => {
      valueRef.current = value

      timerRef.current && clearTimeout(timerRef.current)

      timerRef.current = setTimeout(() => {
        if (valueRef.current === value) {
          callback(value, ...args)
          valueRef.current = defaultValue
        }
      }, delay || 200)
    },
    [callback]
  )

  const cancel = useCallback(() => {
    valueRef.current = defaultValue
  }, [])

  return [start, cancel]
}

export default useHoverDelay
